export default "__VITE_ASSET__CIxnN8Wn__"